export const messages = {
  page: {
    title: {
      id: 'dashboard.Page.Title',
      defaultMessage: 'Welcome, {firstName}',
    },
    titleDescription: {
      id: 'dashboard.Page.Description',
      defaultMessage: 'You are viewing the health information for {patientFirstName} {patientLastName}.',
    },
  },
};
